import PS from '../../MonitoringApiService'

// const generateMockBatteryLogData = ({ batterySerialNos, fromDate, toDate }) => {
//   const data = [];
//   const startDate = new Date(fromDate);
//   const endDate = new Date(toDate);
//   // console.log("generateMockBatteryLogData: ", batterySerialNos, startDate, endDate);
//   if (batterySerialNos.length === 0) {
//     return [];
//   }
//   if (startDate > endDate) {
//     return [];
//   }
//   if (!startDate || !endDate) {
//     return [];
//   }
//   while (startDate <= endDate) {
//     let seconds = 0;
    
//     // 20초 간격으로 데이터 추가
//     while (seconds < 60) {
//       const yyyy = String(startDate.getFullYear());
//       const mm = String(startDate.getMonth() + 1).padStart(2, "0");
//       const dd = String(startDate.getDate()).padStart(2, "0");
//       const hh = String(startDate.getHours()).padStart(2, "0");
//       const mi = String(startDate.getMinutes()).padStart(2, "0");
//       const ss = String(seconds).padStart(2, "0");

//       data.push({
//         id: Math.random().toString(36).substring(2, 15), // 랜덤 ID 생성
//         deviceCompany: "NANOOM",
//         serialNo: batterySerialNos[0], // 첫 번째 배터리 시리얼 번호 사용
//         siteNo: Math.floor(Math.random() * 100000000), // 랜덤 사이트 번호
//         rtuId: String(Math.floor(Math.random() * 100)),
//         deviceNo: Math.floor(Math.random() * 100),
//         state: Math.floor(Math.random() * 2),
//         systemAuto: Math.floor(Math.random() * 2),
//         systemManual: Math.floor(Math.random() * 2),
//         chargeOn: Math.floor(Math.random() * 2),
//         disChargeOn: Math.floor(Math.random() * 2),

//         s1SaltNaclLv: Math.floor(20 + Math.random() * 5), // 20 ~ 25
//         b1BaseNaohLv: Math.floor(2 + Math.random() * 1), // 2 ~ 3
//         a1AcidHclLv: Math.floor(10 + Math.random() * 10), // 10 ~ 20
//         e1ElecNa2so4Lv: Math.floor(100 + Math.random() * 50), // 100 ~ 150
//         s2SaltNaclLv: Math.floor(600 + Math.random() * 100), // 600 ~ 700
//         b2BaseNaohLv: Math.floor(300 + Math.random() * 50), // 300 ~ 350
//         a2AcidHclLv: Math.floor(500 + Math.random() * 50), // 500 ~ 550
//         d1DrainLv: Math.floor(3 + Math.random() * 3), // 3 ~ 6

//         s1SaltNaclPh: Math.floor(30 + Math.random() * 5), // 30 ~ 35
//         b1BaseNaohPh: Math.floor(90 + Math.random() * 5), // 90 ~ 95
//         a1AcidHclPh: Math.floor(20 + Math.random() * 5), // 20 ~ 25
//         e1ElecNa2so4Ph: Math.floor(10 + Math.random() * 10), // 10 ~ 20
//         s2SaphNaclPh: Math.floor(50 + Math.random() * 5), // 50 ~ 55
//         b2BaseNaohPh: Math.floor(60 + Math.random() * 5), // 60 ~ 65
//         a2AcidHclPh: Math.floor(20 + Math.random() * 5), // 20 ~ 25

//         s1SaltNaclFlow: (10 + Math.random() * 5).toFixed(2), // 10 ~ 15
//         b1BaseNaohFlow: (5 + Math.random() * 3).toFixed(2), // 5 ~ 8
//         a1AcidHclFlow: (12 + Math.random() * 4).toFixed(2), // 12 ~ 16
//         e1ElecNa2so4Flow: (8 + Math.random() * 5).toFixed(2), // 8 ~ 13
//         s2SaltNaclFlow: (15 + Math.random() * 5).toFixed(2), // 15 ~ 20
//         b2BaseNaohFlow: (7 + Math.random() * 4).toFixed(2), // 7 ~ 11
//         a2AcidHclFlow: (18 + Math.random() * 6).toFixed(2), // 18 ~ 24

//         s1SaltNaclPressure: (5 + Math.random() * 3).toFixed(2), // 5 ~ 8
//         b1BaseNaohPressure: (10 + Math.random() * 5).toFixed(2), // 10 ~ 15
//         a1AcidHclPressure: (8 + Math.random() * 3).toFixed(2), // 8 ~ 11
//         e1ElecNa2so4Pressure: (12 + Math.random() * 4).toFixed(2), // 12 ~ 16
//         s2SaltNaclPressure: (15 + Math.random() * 5).toFixed(2), // 15 ~ 20
//         b2BaseNaohPressure: (7 + Math.random() * 4).toFixed(2), // 7 ~ 11
//         a2AcidHclPressure: (18 + Math.random() * 6).toFixed(2), // 18 ~ 24

//         s1SaltNaclCond: Math.floor(50 + Math.random() * 10), // 50 ~ 60
//         b1BaseNaohCond: Math.floor(40 + Math.random() * 10), // 40 ~ 50
//         a1AcidHclCond: Math.floor(30 + Math.random() * 10), // 30 ~ 40
//         e1ElecNa2so4Cond: Math.floor(20 + Math.random() * 10), // 20 ~ 30
//         s2SaltNaclCond: Math.floor(60 + Math.random() * 10), // 60 ~ 70
//         b2BaseNaohCond: Math.floor(70 + Math.random() * 10), // 70 ~ 80
//         a2AcidHclCond: Math.floor(80 + Math.random() * 10), // 80 ~ 90

//         panelInputValtage: (40 + Math.random() * 10).toFixed(2), // 40 ~ 50
//         panelInputAmprere: (20 + Math.random() * 5).toFixed(2), // 20 ~ 25
//         panelPower: (50 + Math.random() * 10).toFixed(2), // 50 ~ 60
//         panelWattage: (30 + Math.random() * 5).toFixed(2), // 30 ~ 35

//         ed1ChargeVoltage: (45 + Math.random() * 5).toFixed(2), // 45 ~ 50
//         ed1ChargeAmprere: (35 + Math.random() * 5).toFixed(2), // 35 ~ 40
//         ed1ChargeWattage: (55 + Math.random() * 5).toFixed(2), // 55 ~ 60
//         ed2DischargeVoltage: (40 + Math.random() * 5).toFixed(2), // 40 ~ 45
//         ed2DischargeAmprere: (25 + Math.random() * 5).toFixed(2), // 25 ~ 30
//         ed2DischargeWattage: (45 + Math.random() * 5).toFixed(2), // 45 ~ 50


//         time: `${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`,
//         yyyy,
//         mm,
//         dd,
//         hh,
//         mi,
//         quarter: Math.ceil(parseInt(mm) / 3),
//       });

//       seconds += 60; // 20초씩 증가
//     }

//     // 다음 분으로 이동
//     startDate.setMinutes(startDate.getMinutes() + 1);
//   }

//   return data;
// };

export const fetchMockBatteryLogData = async (params) => {
  try {
    const batteryDataFromApi = await PS.getBatteryPeriod(params);
    return batteryDataFromApi;
  } catch (error) {
    console.error("Error fetching battery data from API:", error);
  }
};
